import { Component, OnInit } from '@angular/core';
import { AdminAccountComponent } from '../account.component';
import { PAGE_ACTION, DEFAULT_PASSWORD, SWAL_COMMMON, SwalErrorHandler } from '../../../../shared/constants';
import { Account } from '../../../../models/account';

declare const swal: any;

@Component({
  selector: 'app-account-create',
  templateUrl: './account-create.component.html',
  styleUrls: ['./account-create.component.scss']
})
export class AdminAccountCreateComponent extends AdminAccountComponent implements OnInit {
  public title = 'Account create';
  public page = PAGE_ACTION.CREATE;
  ngOnInit() {
    this.item = new Account();
    this.createForm();
  }

  public onSave() {
    let data = this.form.value;
    this.apiService.create(data)
    .takeUntil(this.ngUnsubscribe)
    .subscribe(res => {
      var credentials = {
        email: data.email,
        password: DEFAULT_PASSWORD
      };
      this.apiService.login(credentials, 'user')
      .takeUntil(this.ngUnsubscribe)
      .subscribe((res: any) => {
        swal(SWAL_COMMMON.UPDATE_SUCCESS).then(() => {
          this.router.navigate([this.path]);
        });
      });
    }, error => {
      swal(SwalErrorHandler.errorMessage(error));
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/account/create/account-create.component.ts